import React from "react";
import {SearchForm} from './searchForm'
import HistoryList from "./historyList"
 const DataHistory = ():JSX.Element => {
    return (
        <>
            <SearchForm/>
            <HistoryList/>
        </>
    )
}
export default DataHistory